// Construction trades ("ammattinimikkeet") used on Finnish construction worksites.
// The `code` is the short identifier shown on the worksite; it is the value stored
// for a user's trade (per employer, on the resource) and the key in a project's
// `tradeHourlyCosts` map. `name` is the Finnish trade name. The four first entries
// (RAM, RM, TJ, S) are the baseline set; the rest cover the other common trades in
// the Finnish construction business.
export const TRADES = [
  { code: 'RAM', name: 'Rakennusammattimies' },
  { code: 'RM', name: 'Rakennusmies' },
  { code: 'TJ', name: 'Työnjohtaja' },
  { code: 'VTJ', name: 'Vastaava työnjohtaja' },
  { code: 'S', name: 'Sähkömies' },
  { code: 'KIR', name: 'Kirvesmies' },
  { code: 'MUU', name: 'Muurari' },
  { code: 'RAU', name: 'Raudoittaja' },
  { code: 'BET', name: 'Betonimies' },
  { code: 'ELE', name: 'Elementtiasentaja' },
  { code: 'TEL', name: 'Telineasentaja' },
  { code: 'ERI', name: 'Eristäjä' },
  { code: 'VES', name: 'Vedeneristäjä' },
  { code: 'LAA', name: 'Laatoittaja' },
  { code: 'MAA', name: 'Maalari' },
  { code: 'MAT', name: 'Mattomies' },
  { code: 'LVI', name: 'LVI-asentaja' },
  { code: 'PUT', name: 'Putkiasentaja' },
  { code: 'IV', name: 'Ilmanvaihtoasentaja' },
  { code: 'MR', name: 'Maanrakentaja' },
  { code: 'KKK', name: 'Koneenkuljettaja' },
  { code: 'NOS', name: 'Nosturinkuljettaja' },
  { code: 'PUR', name: 'Purkutyöntekijä' },
  { code: 'SII', name: 'Loppusiivooja' },
  { code: 'HAR', name: 'Harjoittelija' },
];

export default TRADES;
